import React from 'react'
import BackArrow from '../../assets/images/Frame_18177.png';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import InactivityTimer from '../../components/InactivityTimer';

const OPDCheckIn = () => {

    const tableData = [
        { "id": "1", "Appointment Date": "07-12-2023", "Consultation Slot": "09:00 AM - 09:15 AM", "Doctor Name": "Dr. Hari Das", "Department": "Cardiology"},
        { "id": "1", "Appointment Date": "07-12-2023", "Consultation Slot": "09:00 AM - 09:15 AM", "Doctor Name": "Dr. Hari Das", "Department": "Cardiology"},
    ];

    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem('kiosk_token');
        navigate("/", { replace: true });
    };

    const token = useSelector((state) => state.auth.kiosk_token);

    // Validate token exists and redirect if not
    React.useEffect(() => {
        if (!token) {
            navigate('/login', { replace: true });
        }
    }, [token, navigate]);

    // Return early if no token to prevent errors
    if (!token) {
        return null;
    }
    
	const decodedToken = jwtDecode(token);

    return (
        <>
            <InactivityTimer />
            <div className='flex items-center'>
                <Link to="/dashboard" className="flex w-28 mt-6 ml-14 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200" style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}>
                    <img src={BackArrow} alt="Back" className="mr-2" style={{ height: '24px', width: '24px' }} />
                    Back
                </Link>
                <span className='mt-8 ml-4' style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}>
                    OPD Check-in
                </span>

                {/* close session button */}
                <button onClick={handleLogout} className='mr-14 mt-5 ml-auto px-2 py-2 text-white bg-red-600 rounded-lg font-semibold text-[20px]'>
                    Close Session
                </button>
            </div>

            {/* Horizontal Line */ }
            <hr className="mt-6 ml-14 mr-14 border-t-1 border-gray-300" />

            {/* Coming Soon Message */}
            <div className="flex items-center justify-center min-h-[60vh]">
                <div className="text-center">
                    <h1 className="text-6xl font-bold text-[#0FA968] mb-4">Coming Soon</h1>
                    <p className="text-2xl text-gray-600">This feature will be available soon.</p>
                </div>
            </div>

            {/* <div className="container mx-auto overflow-x-auto py-4 px-1">
                <div className="relative overflow-x-auto rounded-md border border-gray-200">
                    <table className="w-full text-sm text-left rtl:text-right text-black">
                        <thead className="text-md text-black uppercase bg-[#EEEEF0]">
                            <tr>
                                <th scope="col" className="px-6 py-3">Appointment Date</th>
                                <th scope="col" className="px-6 py-3">Consultation Slot</th>
                                <th scope="col" className="px-6 py-3">Doctor Name</th>
                                <th scope="col" className="px-6 py-3">Department</th>
                                <th scope="col" className="px-6 py-3">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.length > 0 && decodedToken.sub === "TCBHU2504290089" ? (
                                tableData.map((data) => (
                                    <tr key={data.id} className='border-b bg-white'>
                                        <td className="px-6 py-2">{data['Appointment Date']}</td>
                                        <td className="px-6 py-2">{data['Consultation Slot']}</td>
                                        <td className="px-6 py-2">{data['Doctor Name']}</td>
                                        <td className="px-6 py-2">{data['Department']}</td>
                                        <button
                                            className='bg-[#0FA968] text-white rounded-lg px-3 py-2'>Check-in
                                        </button>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="px-6 py-4 text-center">No OPD Check In Data Available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div> */}
            
            {/* <div className="flex justify-center mt-6">
                <Link to="/session-end" className='px-2 py-2 text-[#EFFEF7] bg-[#0FA968] rounded-lg font-semibold text-[16px]'>
                    Complate Session
                </Link>
            </div> */}
        </>
    )
}

export default OPDCheckIn